'use strict';

/**
 * @ngdoc directive
 * @name 360StoreAngularApp.directive:stRenewalPriceBreakdown
 * @description
 * # stRenewalPriceBreakdown
 * Itemizes exactly why a renewal costs what it does. Shown to admins in the renewal preview, and to customers in
 * their license details. Customers see only the subscription case, where a recurring charge needs explaining; the
 * diagnostic columns are admin-only.
 */
angular.module('360StoreAngularApp')
	.directive('stRenewalPriceBreakdown', function (BUILD_DATE) {
		return {
			restrict: 'E',
			scope: {
				details: '<',
				billingPeriod: '<',
				promo: '<',
				autoRenew: '<',
				subscription: '<',
				isAdmin: '<'
			},
			templateUrl: 'views/st-renewal-price-breakdown.html?v=' + BUILD_DATE,
			/**
			 * @param $scope {$scope & {details: RenewalPriceDetails, billingPeriod: ('Monthly'|'Quarterly'|'Annual'|null), promo: PromoCodeLimitedDTO, autoRenew: boolean, subscription: boolean, isAdmin: boolean}}
			 */
			controller: function ($scope, BILLING_PERIODS) {
				const period = () => BILLING_PERIODS.find(o => o.id === ($scope.billingPeriod || 'Annual'));

				$scope.periodLabel = () => period().label;

				$scope.periodTermNoun = () => period().termNoun;

				/**
				 * @return {number} what they will actually be charged: the auto-renew rate if it applies, less any renewal promo
				 */
				$scope.netPrice = () => {
					const base = $scope.autoRenew ? $scope.details.renewalPriceWithAutoRenewDiscount : $scope.details.renewalPrice;
					return base * (100 - ($scope.promo?.creditPercent || 0)) / 100;
				};
			}
		};
	});
